import { render, staticRenderFns } from "./FileImportProvider.vue?vue&type=template&id=7db4c96c&scoped=true&"
import script from "./FileImportProvider.vue?vue&type=script&lang=js&"
export * from "./FileImportProvider.vue?vue&type=script&lang=js&"
import style0 from "./FileImportProvider.vue?vue&type=style&index=0&id=7db4c96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db4c96c",
  null
  
)

export default component.exports